import React from "react";

const BadgeAlert = ({ value, color }) => {

    const checkDigits = (value) => {
        const str = String(value);
        if (str.length === 1) {
            return "1 digit";
        }
        else if (str.length === 2) {
            return "2 digits";
        }
        else {
            return "empty";
        }
    };

    const checkValue = checkDigits(value);
    const oneDigit = checkValue === "1 digit";
    const twoDigit = checkValue === "2 digits";
    const emptyvalue = checkValue === "empty";


    return (
        <div className="badge-alert-container"
            style={{
                backgroundColor: `var(--${color})`,
                height: oneDigit || twoDigit ? "16px" : "8px",
                width: oneDigit ? "16px" : twoDigit ? "22px" : "8px",
                minWidth: twoDigit ? "22px" : null,
                borderRadius: twoDigit ? "50px" : "50%"
            }}
        >
            {value}
        </div>
    );
};

export default BadgeAlert;
